<template>
  <div>
    <v-divider v-if="$vuetify.display.mdAndUp || index > 0"/>
    <v-list-item
        class="px-0"
    >
      <v-row no-gutters="true">
        <v-col cols="10" align-self="center">
          <v-row no-gutters="true">
            <v-col cols="2">
              <p>
                {{ createdAt }}
              </p>
            </v-col>
            <v-col>
              <p>{{ title }}</p>
            </v-col>
          </v-row>
        </v-col>
        <v-col
            cols="2"
        >
          <v-row
              no-gutters="true"
              justify="center"
          >
            <v-btn
                class="my-2"
                icon="mdi-download-circle"
                @click="downloadInvoice"
            />
          </v-row>
        </v-col>
      </v-row>
    </v-list-item>
  </div>
</template>

<script>
export default {
  name: "InvoiceListItem",
  emits: ['downloadInvoice'],
  props: {
    id: String,
    index: Number,
    title: String,
    createdAt: String,
    size: String
  },
  methods: {
    downloadInvoice() {
      this.$emit('downloadInvoice', this.id)
    }
  }
}
</script>

<style scoped>

</style>